import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Change to useNavigate
import Header from '../../components/header1/Header1';
import Footer from '../../components/footer/Footer';
import bannerImage from '../../elements/hero-banner-login-page.png';
import mobileBannerImage from '../../elements/mobile_bg.png';
import { loginUser } from "../../services/studentportalapis";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedInState, setUserRole } from "./loginSlice";
import Logo from "../../elements/Agivant-AMP-D-SE-Logo-Final 1.png";

const Login = () => {
  const loginInfo = useSelector((store) => store.loggedInState);
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // State for error messages
  const navigate = useNavigate(); // Initialize useNavigate
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent default form submission

    try {
      // Call the login API with credentials
      const response = await loginUser({ email, password });

      if (response.message === "Login successful") {
        dispatch(setLoggedInState(true));
        dispatch(setUserRole(response.studentDetails.userRole.toLowerCase()));
        // If login was successful, navigate to the dashboard
        localStorage.setItem('student-details', JSON.stringify(response.studentDetails));

        if (response.studentDetails.userRole !== null && response.studentDetails.userRole.toLowerCase() === "admin") {
          navigate("/admin");
        } else {
          navigate("/dashboard");
        }
      } else if (response.error) {
        // Show error message from the response
        setErrorMessage(response.error);
      }
    } catch (error) {
      console.error('Login failed:', error);
      setErrorMessage('Invalid Username or Password!!');
    }
  };


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleForgotPassword = () => {
    navigate('/forgot-password'); // Redirect to Forgot Password page
  };

  return (
    <div className="login">
      <Header />
      <div
        className="grid grid-cols-1 md:grid-cols-2 min-h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url(${isMobile ? mobileBannerImage : bannerImage})`,
        }}>
      
        {/* Left Side */}
        <div className="flex items-center justify-center p-4 sm:p-8">
          <div className="w-full max-w-md p-6 md:p-4 sm:p-2 rounded-lg">

            <div className='flex justify-center'>
              {isMobile && <img className='w-2/3 h-2/3' src={Logo} alt="Logo" />}
            </div>

            <h2 className="text-2xl sm:text-3xl text-white font-bold text-center mb-4">
              Welcome to Agivant AI Amp'd Software Engineering
            </h2>

            <form onSubmit={handleLogin}>
              {errorMessage && ( // Display error message if exists
                <div className="m-2 text-[#FFAA00] font-bold text-center">{errorMessage}</div>
              )}

              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-white font-semibold mb-2"
                >
                  Email Address<span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="password"
                  className="block text-white font-semibold mb-2"
                >
                  Password<span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  id="password"
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)} // Update state on change
                  required // Add required validation
                />
              </div>

              <div className="flex items-center justify-between mb-2">
                <label className="inline-flex items-center">
                  <input type="checkbox" className="form-checkbox h-3 w-3 text-blue-600" />
                  <span className="utems-start ml-2 text-white">Remember Me</span>
                </label>
                <a
                  href="/forgot-password"
                  onClick={handleForgotPassword}
                  className="items-start text-indigo-200 hover:underline cursor-pointer"
                >
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className="w-full bg-red-600 text-white p-3 rounded-md font-semibold hover:bg-red-700 transition"
              >
                Login
              </button>
            </form>

            <p className=" text-base sm:text-normal text-center text-white mb-2">
              Don't have an account?{' '}
              <a href="/register" className="text-indigo-200 hover:underline">
                Register here
              </a>
            </p>
          </div>
        </div>

        {/* Right Side (can remain empty or have background) */}
        <div className="hidden md:block"></div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
